import { enumsPayment } from '@itarget/shared';
import { calculateOfferBusinessRules } from '../containers/offers/utils/offerBusinessRules';

const calculateDisplayRules = (isLoadingScreen, detailing, user, category, businessRules, freeAccess, centerCost) => ({
  requestCategory: !isLoadingScreen && 
                  detailing && 
                  user?.data?.id && 
                  !detailing?.plp_id && 
                  category?.data?.length >= 1 && 
                  !detailing?.status_inscricao,
  
  allowsDisplayOfferValues: (!user?.data?.id || detailing?.plp_id || detailing?.status_inscricao) && !isLoadingScreen,
  
  allowsDisplayOfTheAmount: !isLoadingScreen && 
                           user?.data?.id && 
                           !businessRules.userStatus.isRegistered && 
                           !businessRules.status.isCourtesy,
  
  allowsDisplayComboAnnuity: businessRules.values.hasComboAnnuity,
  
  allowsDisplayDiscountedComboAnnuity: businessRules.values.hasDiscountedComboAnnuity,
  
  allowsDisplayTotalAmount: businessRules.values.hasTotalAmount,
  
  allowsDisplayReference: businessRules.values.hasReference,
  
  allowsDisplayWaitingList: businessRules.status.hasWaitingList,
  
  allowsDisplayCourtesy: !detailing?.status_inscricao && businessRules.status.isCourtesy && !businessRules.status.isSoldOut,
  
  availableForPurchase: !isLoadingScreen && 
                       (!detailing?.status_inscricao || businessRules.status.canBuyMore) && 
                       !businessRules.status.isCourtesy && 
                       !businessRules.status.isSoldOut && 
                       (!user?.data?.id || !!detailing?.plp_id),
  
  soldOut: !isLoadingScreen && businessRules.status.isSoldOut && !detailing?.status_inscricao,
  
  pendingPayment: businessRules.userStatus.hasPendingPayment,
  
  shoppingCartPayment: businessRules.userStatus.hasShoppingCartPayment,
  
  generatedCharge: businessRules.userStatus.hasGeneratedCharge,
  
  paymentMade: businessRules.userStatus.isRegistered && !businessRules.status.isCourtesy && detailing?.plp_id,
  
  enableWatchConditions: businessRules.userStatus.canWatchContent,
  
  courtesy: businessRules.status.isCourtesy,
  
  releasedContent: businessRules.content.hasReleasedContent,
  
  unavailable: !isLoadingScreen && 
              (!detailing || (user?.data?.id && !detailing?.plp_id && category?.data?.length === 0)) && 
              !freeAccess,
  
  configuredForDistanceLearning: centerCost?.tipo_centro_custo === 7,
  
  transmissionAvailable: businessRules.content.hasTransmission,
  
  classesAvailable: businessRules.content.hasClasses,
  
  enableMindsRadiologyUrl: businessRules.content.hasMindsRadiology,
  
  displayCashback: businessRules.userStatus.canUseCashback,
  
  displayAdherenceTerms: businessRules.userStatus.hasAdherenceTerms && !isLoadingScreen
});

export const useOfferRules = ({
  isLoadingScreen,
  detailing,
  user,
  category,
  annuities,
  totalAnnuity,
  soldOut,
  canBuyMore,
  hasPendingAnnuities,
  collectionFilteredByCampaignId,
  mindsRadiologyUrl,
  freeAccess,
  centerCost
}) => {
  const businessRules = calculateOfferBusinessRules({
    detailing,
    user,
    category,
    annuities,
    totalAnnuity,
    soldOut,
    canBuyMore,
    hasPendingAnnuities,
    collectionFilteredByCampaignId,
    mindsRadiologyUrl,
    freeAccess,
    centerCost
  });

  return calculateDisplayRules(
    isLoadingScreen,
    detailing,
    user,
    category,
    businessRules,
    freeAccess,
    centerCost
  );
}; 